import { T } from "./global.js";

function cn(...classNames) {
  return classNames.filter(Boolean).join(" ");
}

function isID(s) {
  return s === "id" || s.includes("_id");
}

function getId(d) {
  const allKeys = Object.keys(d);
  if (allKeys.includes("id")) {
    return d["id"];
  } else {
    const idKey = allKeys.find((k) => k.includes("_id"));
    if (idKey) {
      return d[idKey];
    } else {
      return null;
    }
  }
}

function getInfoObjId(infoObject, obj) {
  const name = infoObject.split(" ").join("_");
  const id = getId(obj);
  return name + id;
}

function getValType(val) {
  if (typeof val === "string" || typeof val === "number") return T.VAL;

  if (Array.isArray(val))
    return val.length > 0 && typeof val[0] === "object" ? T.DB : T.LIST;

  if (val !== null && typeof val === "object") return T.OBJ;

  console.warn("Unknown type:", val, typeof val);
  return undefined;
}

function translate_ds(ds_org) {
  const ds = JSON.parse(ds_org);
  return [ds.info_object, ds.schema];
}

function translate_strs(ss_org) {
  const ss = JSON.parse(ss_org.replace(/'/g, '"'));
  return [ss.structure, ss.attributes];
}

function pluralToSingular(plural) {
  // Common irregular plural nouns
  const irregulars = {
    children: "child",
    men: "man",
    women: "woman",
    feet: "foot",
    teeth: "tooth",
    geese: "goose",
    mice: "mouse",
    lice: "louse",
    data: "datum",
    criteria: "criterion",
    references: "reference",
    examples: "example",
  };

  // Check for irregular plurals
  if (irregulars[plural.toLowerCase()]) {
    return irregulars[plural.toLowerCase()];
  }

  // Regular plural rules
  if (plural.endsWith("ies")) {
    return plural.slice(0, -3) + "y";
  } else if (plural.endsWith("es")) {
    return plural.slice(0, -2);
  } else if (plural.endsWith("s")) {
    return plural.slice(0, -1);
  }
  // If no rule matches, return the input word as it is (assuming it's already singular)
  return plural;
}

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function highlgihtInfoObj(cn) {
  [...document.querySelectorAll("." + cn)].forEach((d) => {
    d.setAttribute("data-state", "highlighted");
  });
}

function clearDataState(cn) {
  [...document.querySelectorAll("." + cn)].forEach((d) => {
    d.setAttribute("data-state", "");
  });
}

function hasSubAttrviews(views) {
  return true;
  views.forEach((v) => {
    if (v.attributeviews && v.attributeviews.length > 0) {
      console.log("!!!!!!!!!!!!");
      return true;
    }
  });

  return false;
}

function getObjName(s) {
  if (typeof s === "string" && s.includes("__")) {
    return s.split("__")[1];
  } else {
    return JSON.stringify(s);
  }
}

function getDisplayName(s) {
  if (typeof s === "string" && s.startsWith("__")) {
    return s;
  } else {
    return "";
  }
}

export {
  cn,
  translate_strs,
  translate_ds,
  pluralToSingular,
  getRandomInt,
  getValType,
  isID,
  getId,
  getInfoObjId,
  highlgihtInfoObj,
  clearDataState,
  hasSubAttrviews,
  getObjName,
  getDisplayName,
};
